import { Image } from "antd";
import Logo from "../../assets/SpectusHRMS.png";
import LoginStyle from "../login/LoginStyle";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import axios from "axios";
import { TextField, Typography, Button } from "@mui/material";
import { toast } from "react-toastify";
import "../login/index.css";
import CryptoJS from "crypto-js";

const { default: env } = require("../../config/env.js");

const ForgotPassword = () => {
  const [preventDoubleClick, setpreventDoubleClick] = useState(false);
  const [inputEmail, setInputEmail] = useState("");
  const [emailerror, setemailerror] = useState("");

  const Navigate = useNavigate();
  const SECRET_KEY = env.REACT_APP_ENCRYPTION_KEY;

  const onFinish = async () => {
    try {

      const data = { email: inputEmail, }

      // Encrypt data
      const encryptedBody = CryptoJS.AES.encrypt(JSON.stringify(data), SECRET_KEY).toString();;

      //Encrypt api endpoint
      const emailVerify = CryptoJS.SHA256("/emailVerify" + SECRET_KEY).toString(CryptoJS.enc.Hex).substring(0, 12);

      const response = await fetch(`${env.backend_api_endpoint}/${emailVerify}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ encryptedData: encryptedBody }),
      });
      if (response.ok) {
        const successData = await response.json();
        if (successData.status === 200) {
          sendOtpMail(successData);
        }
      }
      if (!response.ok) {
        const error = await response.json();
        if (error.status === 404) {
          toast.error(error.message, {
            position: toast.POSITION.TOP_RIGHT,
            toastId: "1",
          });
        }
        if (error.status === 403) {
          toast.error(error.message, {
            position: toast.POSITION.TOP_RIGHT,
            toastId: "1",
          });
        }
      }
    } catch (error) {
      console.error("Error Forgot Password in:", error.message);
    }
  };
  const sendOtpMail = async (successData) => {
    const verification_code = Math.floor(100000 + Math.random() * 900000);

    var date = new Date();
    var time = date.toLocaleString([], {
      hour: "2-digit",
      minute: "2-digit",
    });
    var d = date.toLocaleDateString([], {
      day: "numeric",
      month: "long",
      year: "numeric",
    });

    var templateParams = {
      to_name: successData?.data?.name,
      to_email: successData?.data?.company_email,
      to_date: `${d}, ${time}`,
      verification_code: verification_code,
      subject: `Reset Password Verification Code ${env.subject_mode}`,
      type: "forgot_password",
      from_email: env.basic_email_params.from_email,
    };

    await axios
      .post(`${env.backend_api_endpoint}/send-email`, { ...templateParams })
      .then(() => {
        setpreventDoubleClick(false);
        toast.success("OTP Sent Successfully !", {
          position: toast.POSITION.TOP_RIGHT,
          toastId: "1",
        });
        Navigate("/email-verification", {
          state: {
            code: verification_code,
            email_address: inputEmail,
            loginUser: successData?.data?.id,
            name: successData?.data?.name,
          },
        });
      })
      .catch((err) => {
        setpreventDoubleClick(false);
        toast.error("Something went wrong please try after sometime !", {
          position: toast.POSITION.TOP_RIGHT,
          toastId: "1",
        });
        console.log(err);
      });
  };
  return (
    <LoginStyle>
      <div className="mainLoginDiv">
        <div className="img_div">
          <Image src={Logo} preview={false}></Image>
        </div>
        <div className="form_card">
          <h3
            style={{
              fontSize: "36px",
              fontWeight: "600",
              color: "#244DA0",
              fontStyle: "normal",
              textAlign: "left",
              padding: "22px",
              fontFamily: "ImportedMilliardBold",
            }}
          >
            Forgot Password
          </h3>
          <div className="form_item">
            <Typography className="label_form">
              Please enter your registered email address to receive a
              verification code{" "}
            </Typography>
            <br />
            <TextField
              placeholder="Email address"
              onChange={(e) => {
                setInputEmail(e.target.value);
                if (e.target.value === "") {
                  setemailerror("Please enter your email!");
                } else {
                  setemailerror("");
                }
                return true;
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  onFinish();
                }
              }}
              autoComplete="off"
              size="medium"
              error={emailerror === "" ? false : true}
              helperText={emailerror}
              style={{
                fontWeight: "500",
                fontSize: "20px",
                fontFamily: "Milliard",
              }}
            />

            <Button
              size="large"
              variant="contained"
              id="submit_btn"
              style={{
                borderRadius: "6px",
                marginTop: "160px",
                marginBottom: "20px",
                fontWeight: "500",
                fontSize: "18px",
                padding: "2px",
                height: "46px",
                textTransform: "none",
                backgroundColor: "rgb(36, 77, 160)",
                color: "white",
                pointerEvents: preventDoubleClick ? "none" : "auto",
                cursor: preventDoubleClick ? "not-allowed" : "pointer",
                opacity: preventDoubleClick ? 0.5 : 1,
              }}
              disabled={preventDoubleClick}
              onClick={() => {
                if (inputEmail === "") {
                  setemailerror("Please enter your email!");
                } else {
                  onFinish();
                }
              }}
            >
              {preventDoubleClick ? "Sending..." : "Send OTP"}
            </Button>
          </div>
        </div>
      </div>
    </LoginStyle>
  );
};

export default ForgotPassword;
